import type { ReactNode } from 'react';

interface Props {
  title: string;
  eyebrow?: string;
  right?: ReactNode;
  /** Leading slot (mobile hamburger) rendered before the title block. */
  left?: ReactNode;
}

export function Topbar({ title, eyebrow, right, left }: Props) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: '20px 28px',
        borderBottom: '1px solid var(--line)',
        background: 'var(--bg)',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
        {left}
        <div style={{ minWidth: 0 }}>
        {eyebrow && (
          <div
            style={{
              fontSize: 11,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: 'var(--ink-3)',
              fontWeight: 600,
            }}
          >
            {eyebrow}
          </div>
        )}
        <div style={{ fontFamily: 'var(--font-display)', fontSize: 26, fontWeight: 600, letterSpacing: '-0.02em' }}>
          {title}
        </div>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>{right}</div>
    </div>
  );
}
